import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";
import QueueSymbol from "@/game-lol/utils/symbol-queue.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";

const BasicStatsObject = {
  assists: Number,
  deaths: Number,
  kills: Number,
  wins: Number,
} satisfies ModelDefinition;

export const model = {
  basicStats: BasicStatsObject,
  championId: String,
  gameCount: Number,
  lastPlayed: String,
  queue: QueueSymbol,
  role: RoleSymbol,
} satisfies ModelDefinition;

const LolPlayerChampionBasicStatsModel = createModel({
  data: {
    playerChampionsStats: [model],
  },
}).transform([model], (data) => data.data.playerChampionsStats);

export type LolPlayerChampionBasicStats = FromModel<
  typeof LolPlayerChampionBasicStatsModel
>;

export default LolPlayerChampionBasicStatsModel;
